import { call, put, takeLatest } from "@redux-saga/core/effects";
import empStatusService from "../../Services/RestApiManager/empStatusManager/empStatusService";
import {
  EMP_STATUS_ACTION,
  errorDocTypesStatus,
  errorDocumentUpload,
  errorEmpStatus,
  errorGetEmpStatus,
  responseDocTypesStatus,
  responseDocumentUpload,
  responseEmpStatus,
  responseGetEmpStatus,
} from "./empStatusActionCreator";

export function* empStatusRequest(action) {
  try {
    const response = yield call(
      empStatusService.shared.empStatusRequest,
      action.data
    );
    yield put(responseEmpStatus(response));
  } catch (error) {
    yield put(errorEmpStatus(error));
  }
}

export function* getEmpStatusRequest(action) {
  try {
    const response = yield call(
      empStatusService.shared.getEmpStatusRequest,
      action.data
    );
    yield put(responseGetEmpStatus(response));
  } catch (error) {
    yield put(errorGetEmpStatus(error));
  }
}

export function* getDocTypesRequest(action) {
  try {
    const response = yield call(
      empStatusService.shared.getDocTypesRequest,
      action.data
    );
    yield put(responseDocTypesStatus(response));
  } catch (error) {
    yield put(errorDocTypesStatus(error));
  }
}

export function* documentUploadRequest(action) {
  try {
    const response = yield call(
      empStatusService.shared.documentsUploadRequest,
      action.data
    );
    yield put(responseDocumentUpload(response));
  } catch (error) {
    yield put(errorDocumentUpload(error));
  }
}

export function* empStatusWatcherSaga() {
  yield takeLatest(EMP_STATUS_ACTION.EMP_STATUS_REQUEST, empStatusRequest);
  yield takeLatest(EMP_STATUS_ACTION.GET_EMP_STATUS_REQUEST,getEmpStatusRequest);
  yield takeLatest(EMP_STATUS_ACTION.GET_DOCTYPE_REQUEST,getDocTypesRequest);
  yield takeLatest(EMP_STATUS_ACTION.REQUEST_DOCUMENT_UPLOAD,documentUploadRequest);
}
